import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=12210790&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=ts"
export * from "./productDetail.vue?vue&type=script&lang=ts"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=12210790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12210790",
  null
  
)

export default component.exports